import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import {  Spinner } from "react-bootstrap";
import { TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import {
  useGetCommoditiesDataQuery,
  useAddStockDataMutation,
} from "./ProcurementApiSlice";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import swal from "sweetalert";
import { useSelector } from "react-redux";
import { selectCurrentRoles } from "features/auth/authSlice";
import {
  Container,
  Grid,
  
} from "@mui/material";

import { AddAddressProcurement } from "./AddAddressProcurement";
import { toast } from "react-toastify";

const AddStock = ({
  user_id,refetch,
  userName,UserData,
  setActiveCard,
  activeCard,cropDetails,refetchFilteredCommodity
  
}) => {
  const [addStock, setAddStock] = useState(false);
  const RolesFromToken = useSelector(selectCurrentRoles);
  const { data: getCommodity, refetch: refetchCommodity } = useGetCommoditiesDataQuery(
    { user_id: user_id },
  );
 
  const [addStockApi] = useAddStockDataMutation();
  const [CommodityData, setCommodityData] = useState([]);
  const [stockaddloading, setAddStockLoading] = useState(false);
  const [cropIdSelected, setCropIdSelected] = useState("");
  const [allowingEditing, setallowingEditing] = useState(false);
  const [addStockData, setAddedStock] = useState({
    crop_name: cropDetails?.commodity?.name,
    quality_parameters: "",
    price: "",
    user: "",
    unit_measurement: "",
    variety: "",
    season: "",
    year: "",
    price_quoted_at: "",
    quoted_type: "",
  });
  const [activeStep, setActiveStep] = useState(0);
  const [stockId, setStockId] = useState("");
  const [stockQuantity, setStockQuantity] = useState("");
 
  

  const Unit = [
    // { title: "Metric Tonne", year: 1990 },
    { title: "Quintal", year: 1991 },
  ];
  const Season = [
    { title: "Rabi", year: 1990 },
    { title: "Kharif", year: 1991 },
    { title: "Zaid", year: 1992 },
  ];
  const Year = [
    { title: 2025, year: 1989 },

    { title: 2024, year: 1990 },
    { title: 2023, year: 1991 },
    { title: 2022, year: 1991 },
    { title: 2021, year: 1991 },
    { title: 2020, year: 1991 },
  ];
  const PriceQuoted = [
    { title: "Warehouse", year: 1990 },
    { title: "TruckLoad", year: 1991 },
  ];
  useEffect(() => {
   
    if (getCommodity) {
      setCommodityData(getCommodity?.data);
    }
  }, [ getCommodity]);
  const handleChange = (name) => (e, value) => {
    if (
      name === "unit_measurement" ||
      name === "season" ||
      name === "year" ||
      name === "quoted_type"
    ) {
      setAddedStock({
        ...addStockData,
        [name]: value,
      });
    } else if (name === "crop_name") {
      setAddedStock({
        ...addStockData,
        [name]: value,
      });
    } else {
      setAddedStock({
        ...addStockData,
        [e.target.name]: e.target.value,
      });
    }
    if (name === "crop_name") {
      const filteredData = CommodityData?.find((item) => item.name === value);
      setCropIdSelected(filteredData?.code);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setAddStockLoading(true);
    let payload;
    if (!allowingEditing) {
      payload = {
        crop_name: addStockData.crop_name,
        price: parseInt(addStockData.price),
        user: RolesFromToken.preferred_username,
        crop_id: cropDetails?.commodity?.code,
        unit_measurement: addStockData.unit_measurement,
        variety: addStockData.variety,
        season: addStockData.season,
        year: addStockData.year,
        quoted_type: addStockData.quoted_type,
      };
    } else {
      payload = {
        crop_name: addStockData.crop_name,
        price: addStockData.price,
        user: RolesFromToken.preferred_username,
        crop_id: cropIdSelected,
        unit_measurement: addStockData.unit_measurement,
        updated_by_id: user_id,
        updated_by_name: userName,
        variety: addStockData.variety,
        season: addStockData.season,
        year: addStockData.year,
        quoted_type: addStockData.quoted_type,
      };
    }

    addStockApi(payload)
      .unwrap()
      .then((data) => {
        if (data.status === 200 || data.status === 201) {
          toast.success("Stock Added Successfully");
          setActiveStep(1);
          setStockId(data.data.id);
          setStockQuantity(data.data.unit_measurement);
          setAddedStock({
            crop_name: "",
            price: "",
            unit_measurement: "",
            variety: "",
            season: "",
            year: "",
            price_quoted_at: "",
          });
          setAddStockLoading(false);
          refetch();
          refetchFilteredCommodity()
          //    if(!allowingEditing || (selectedfileSend && selectedfileSendDuplcate)){
          // const formData = new FormData();
          // formData.append("file", selectedfileSend);
          // formData.append("entity_type", "Seller");
          // formData.append("user_id", RolesFromToken.organization_id);
          // formData.append("category", "Stock");
          // formData.append("pattern", 1);
          // formData.append("stock", data.data.id);
          // uploadProcMedia(formData)
          //   .unwrap()
          //   .then((data) => {
          //     SetSelectedFileSend("");
          //   })
          //   .catch((error) => {
          //     setAddStockLoading(false);

          //   });
          //     }
          //     setTimeout(() => {
          //       refetch();
          //     }, 1000);
        }
      })
      .catch((error) => {
        swal("Oops Something went wrong !!", {
          icon: "warning",
          title: error.data.message,
          timer: 2000,
        });
        setAddStockLoading(false);
      });
  };

  const handleStockModal = (listVal, value) => {
    // refetchCommodity();
    if (value) {
      setallowingEditing(true);
     
      setAddedStock({
        crop_name: listVal.crop_name,
        price: listVal.price,
        unit_measurement: listVal.unit_measurement,
        variety: listVal.variety,
        season: listVal.season,
        year: listVal.year,
        address: listVal.address,
        quoted_type: listVal.quoted_type,
      });
      setStockQuantity(listVal.unit_measurement);

      setCropIdSelected(listVal.crop_id);
      setStockId(listVal.id);
    }
    setAddStock(true);
    setActiveStep(0);
  };





  return (
    <div>
     
     
          <Container maxWidth="xm">
            <Grid container direction="column" alignItems="center" spacing={2}>
              <Grid item xs={12}>
                {activeStep === 0 && (
                  <form onSubmit={handleSubmit}>
                    <div className="row mt-3">
                      <div className="col-lg-12  mb-3">
                        <Autocomplete
                          id="free-solo-2-demo"
                          name="crop_name"
                          value={addStockData.crop_name}
                          // disabled={allowingEditing ? true : false}
                          disabled

                          disableClearable
                          onChange={handleChange("crop_name")}
                          options={CommodityData?.map((option) => option.name)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Commodity"
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                type: "search",

                              
                              }}
                            />
                          )}
                        />
                      </div>

                      <div className="col-lg-6 mb-3 mt-1">
                        <TextField
                          id="variety"
                          label="Variety"
                          name="variety"
                          value={addStockData.variety}
                          required
                          onChange={handleChange("variety")}
                          multiline
                          size="small"
                          maxRows={2}
                          style={{ width: "100%" }}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>

                      <div className="col-lg-6 mb-3 mt-1 ">
                        <Autocomplete
                          id="unit_measurement"
                          name="unit_measurement"
                          disableClearable
                          value={addStockData.unit_measurement}
                          onChange={handleChange("unit_measurement")}
                          options={Unit?.map((option) => option.title)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Unit"
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                type: "search",
                               
                              }}
                            />
                          )}
                        />
                      </div>
                      <div className="col-lg-6  mb-3 mt-1">
                        <TextField
                          id="price"
                          label="Price/Unit (Rs)"
                          name="price"
                          value={addStockData.price}
                          required
                          size="small"
                          multiline
                          maxRows={2}
                          onKeyPress={(event) => {
                            if (!/\d/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onChange={handleChange("price")}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                      <div className="col-lg-6 mb-3 mt-1">
                        <Autocomplete
                          id="quoted_type"
                          name="quoted_type"
                          disableClearable
                          value={addStockData.quoted_type}
                          onChange={handleChange("quoted_type")}
                          options={PriceQuoted?.map((option) => option.title)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Price Estimated For"
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                type: "search",
                              
                              }}
                            />
                          )}
                        />
                      </div>

                      <div className="col-lg-6 mb-3 mt-1">
                        <Autocomplete
                          id="year"
                          name="year"
                          disableClearable
                          value={addStockData.year}
                          onChange={handleChange("year")}
                          style={{ width: "100%" }}
                          options={Year?.map((option) => option.title)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Year"
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                type: "search",
                              
                              }}
                            />
                          )}
                        />
                      </div>
                      <div className="col-lg-6  mb-3 mt-1">
                        <Autocomplete
                          id="season"
                          name="season"
                          disableClearable
                          value={addStockData.season}
                          style={{ width: "100%" }}
                          onChange={handleChange("season")}
                          options={Season?.map((option) => option.title)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Season"
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                type: "search",
                              
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>

                    <div className="mt-4 mb-5">
                      {allowingEditing ? (
                        <Button
                          variant="contained"
                          className="float-end mx-2 mb-2"
                          color="primary"
                          size="small"
                          onClick={() => setActiveStep(1)}
                        >
                          Update Location
                        </Button>
                      ) : (
                        ""
                      )}
                      <Button
                        variant="contained"
                        className="float-end mx-2 mb-2"
                        color="success"
                        type="submit"
                        size="small"
                      >
                        Submit &nbsp;
                        {stockaddloading ? <Spinner size="sm" /> : ""}
                      </Button>
                    </div>
                  </form>
                )}
                {activeStep === 1 && (
                  <>
                    <div>
                      <AddAddressProcurement
                        stockId={stockId}
                        setStockId={setStockId}
                        UserData={UserData}
                        setActiveStep={setActiveStep}
                        refetch={refetch}
                        setActiveCard={setActiveCard}
                        allowingEditing={allowingEditing}
                        stockQuantity={stockQuantity}
                        RolesFromToken={RolesFromToken}
                      />
                    </div>
                  </>
                )}
              </Grid>
              {/* <Grid item xs={12} className="mt-3">
                {activeStep > 0 && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClose}
                    size="small"
                    style={{ float: "right" }}
                  >
                    Skip
                  </Button>
                )}
              </Grid> */}
            </Grid>
          </Container>
     
      
    </div>
  );
};

export default AddStock;
